import { Box, Typography } from '@mui/material';
import { FC } from 'react';
// import i18n from '../../app/i18n';
import { useTranslation } from 'react-i18next';
import { dateFormat } from 'src/hooks';

interface Props {
  event: Record<string, any>;
  onClick: (event: Record<string, any>) => void;
}

const CalendarEvent: FC<Props> = ({ event, onClick }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  if (!event) return null;

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    onClick(event);
  };

  return (
    <Box
      sx={{
        bgcolor: event.backgroundColor || 'primary.main',
        p: 1,
        borderRadius: 1,
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <Typography variant="h6" mb={0.5} fontSize={{ xs: 12, lg: 13, xl: 15 }}>
        {dateFormat(new Date(event.start), 'T')}
        {event.end && <> - {dateFormat(new Date(event.end), 'T')}</>}
      </Typography>
      <Typography
        variant="caption"
        component="div"
        sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
        title={event.title[locale]}
      >
        {event.title[locale]}
      </Typography>
    </Box>
  );
};

export default CalendarEvent;
